import { render, staticRenderFns } from "./material-avg-report.vue?vue&type=template&id=35225d61"
import script from "./material-avg-report.vue?vue&type=script&lang=js"
export * from "./material-avg-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports